import React, { FC, memo } from 'react'

import { Button } from '@/components/Button/Button'
import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { RefreshQrProps } from '@/types/componentsPropsTypes'

import { DescWrapper, TextElem, TitleElem } from './styles'

const RefreshQrRow: FC<RefreshQrProps> = ({
  title,
  mobileStyle = false,
  handler,
}) => {
  const { t } = useCommonTranslation()
  return (
    <DescWrapper $mobileStyle={mobileStyle}>
      {title && <TitleElem>{title}</TitleElem>}
      <TextElem>{t('qrRefresh')}</TextElem>
      <TextElem>{t('qrRefresh2')}</TextElem>
      <Button
        iconSrc={icons.register.refreshIcon}
        text={t('refresh')}
        onClick={handler}
      />
    </DescWrapper>
  )
}

export const RefreshQr = memo(RefreshQrRow)
